import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getAllVehiclesAsRack } from '../../../features/assets/assetsSlice';
import { gensetFocusAssetIdSelector, gensetViewportPaddingSelector, setNeedBounding } from '../../../features/map/mapSlice';

const GoogleMapGensetBounder = ({ map }) => {
    const dispatch = useDispatch();
    const focusedAssetId = useSelector(gensetFocusAssetIdSelector);
    const viewportPadding = useSelector(gensetViewportPaddingSelector);
    const rack = useSelector(getAllVehiclesAsRack);

    useEffect(() => {
        if (!map || !focusedAssetId) return;
        const assetData = rack?.[`${focusedAssetId}`];
        if (!assetData?.coreData) {
            dispatch(setNeedBounding(false));
            return;
        }
        const { lat, lng } = assetData.coreData;
        if (!window.google) return;
        const latlng = new window.google.maps.LatLng(lat, lng);
        if (viewportPadding && map.getProjection && map.getProjection()) {
            const div = map.getDiv();
            const width = div?.offsetWidth || 0;
            const height = div?.offsetHeight || 0;
            const left = Math.max(0, viewportPadding.left || 0);
            const top = Math.max(0, viewportPadding.top || 0);
            const right = Math.max(0, viewportPadding.right || 0);
            const bottom = Math.max(0, viewportPadding.bottom || 0);
            const viewportWidth = Math.max(0, width - left - right);
            const viewportHeight = Math.max(0, height - top - bottom);
            const viewportCenterX = left + viewportWidth / 2;
            const viewportCenterY = top + viewportHeight / 2;
            const offsetX = viewportCenterX - width / 2;
            const offsetY = viewportCenterY - height / 2;
            const scale = Math.pow(2, map.getZoom());
            const worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
            const worldCoordinateNewCenter = new window.google.maps.Point(
                worldCoordinateCenter.x - (offsetX / scale),
                worldCoordinateCenter.y - (offsetY / scale)
            );
            map.setCenter(map.getProjection().fromPointToLatLng(worldCoordinateNewCenter));
        } else {
            map.setCenter(latlng);
        }
        dispatch(setNeedBounding(false));
    }, [dispatch, focusedAssetId, map, rack, viewportPadding]);

    return null;
};

export default GoogleMapGensetBounder;
